/*!
 * SPDX-FileCopyrightText: 2016 Nextcloud GmbH and Nextcloud contributors
 * SPDX-FileCopyrightText: 2014 ownCloud, Inc.
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

/**
 * @deprecated 16.0.0 Use OCP.AppConfig instead
 */
export const appConfig = window.oc_appconfig || {}
